module.exports = __webpack_public_path__ + "img/out-of-stock.1021e358.png";